<script>

import { events } from '@nuskin/ns-util'

export default {
    methods: {
        publishEvent: function (eventName, payload, ev) {
            events.tag(eventName, { ...payload })

            if (ev) {
                ev.preventDefault()
            }
        }
    }
}

</script>
